import { render, staticRenderFns } from "./TreatmentPlotList.vue?vue&type=template&id=2d1fed5d&scoped=true&"
import script from "./TreatmentPlotList.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlotList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlotList.vue?vue&type=style&index=0&id=2d1fed5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fed5d",
  null
  
)

export default component.exports